import { MonthPicker as AntdMonthPicker } from "@empglabs/backoffice-ui-kit"

const MonthPicker = props => {
  return <AntdMonthPicker {...props} />
}

export default MonthPicker
